const body = document.querySelector('body');
function productGridChanger () {
  if (body.classList.contains('collection')){
    const firstColumn = document.querySelector('.grid-view-first-column');
    const secondColumn = document.querySelector('.grid-view-second-column');
    const thirdColumn = document.querySelector('.grid-view-third-column');
    const firstColumnMobile = document.querySelector('.grid-view-first-column-mobile');
    const secondColumnMobile = document.querySelector('.grid-view-second-column-mobile');
    
    const gridView = document.querySelector('#ProductGridContainer #product-grid');
    
    firstColumn.addEventListener('click', function() {
        gridView.classList.remove('grid--3-col-desktop', 'grid--4-col-desktop');
        gridView.classList.add('grid--2-col-desktop');
        removeActiveClass();
        firstColumn.classList.add('active');
    });
    
    secondColumn.addEventListener('click', function() {
        gridView.classList.remove('grid--2-col-desktop', 'grid--4-col-desktop');
        gridView.classList.add('grid--3-col-desktop');
        removeActiveClass();
        secondColumn.classList.add('active');
    });
    
    thirdColumn.addEventListener('click', function() {
        gridView.classList.remove('grid--2-col-desktop', 'grid--3-col-desktop');
        gridView.classList.add('grid--4-col-desktop');
        removeActiveClass();
        thirdColumn.classList.add('active');
    });

     firstColumnMobile.addEventListener('click', function() {
       console.log("you are clicking on first div")
        gridView.classList.remove('grid--2-col-tablet-down');
        gridView.classList.add('grid--1-col-tablet-down');
        firstColumnMobile.classList.add('Active');
        secondColumnMobile.classList.remove('Active');
    });

     secondColumnMobile.addEventListener('click', function() {
        gridView.classList.remove('grid--1-col-tablet-down');
        gridView.classList.add('grid--2-col-tablet-down');
        firstColumnMobile.classList.remove('Active');
        secondColumnMobile.classList.add('Active');
    });
    
    function removeActiveClass() {
      const gridViewChangers = document.querySelectorAll('.grid-view-changer');  
      gridViewChangers.forEach(element => {
        element.classList.remove('active');
      });
    }
  }
}

function checkActiveGridView() {
  const activeGridView = document.querySelector('.grid-view-changer.active');
  const gridView = document.querySelector('#ProductGridContainer #product-grid');

  if (activeGridView) {
    const firstColumn = activeGridView.classList.contains('grid-view-first-column');
    const secondColumn = activeGridView.classList.contains('grid-view-second-column');
    const thirdColumn = activeGridView.classList.contains('grid-view-third-column'); 
    const firstColumnMobile = activeGridView.classList.contains('grid-view-first-column-mobile'); 
    const secondColumnMobile = activeGridView.classList.contains('grid-view-second-column-mobile'); 

    if (firstColumn) {
      removeAnimationClass();
      gridView.classList.remove('grid--3-col-desktop');
      gridView.classList.add('grid--2-col-desktop');
    } else if (secondColumn) {
      removeAnimationClass();
      gridView.classList.remove('grid--2-col-desktop');
      gridView.classList.add('grid--3-col-desktop');
    } else if (thirdColumn) {
      removeAnimationClass();
      gridView.classList.remove('grid--2-col-desktop');
      gridView.classList.add('grid--4-col-desktop');
    }
    else if (firstColumnMobile) {
      removeAnimationClass();
      gridView.classList.remove('grid--2-col-tablet-down');
      gridView.classList.add('grid--1-col-tablet-down');
    }
    else if (secondColumnMobile) {
      removeAnimationClass();
      gridView.classList.remove('grid--1-col-tablet-down');
      gridView.classList.add('grid--2-col-tablet-down');
    }
  }

  function removeAnimationClass() {
    const gridItems = document.querySelectorAll('#product-grid li.grid__item');
  
    gridItems.forEach(element => {
      element.classList.remove('scroll-trigger--cancel');
    });
  }  
}


productGridChanger ();

// Custom Flow code

// document.addEventListener("DOMContentLoaded", function() {
//   var unstitchedInput = document.querySelector("input[value='Unstitched']");
//   var stitchedInput = document.querySelector("input[value='Stitched']");
//   var customOptionsDiv = document.querySelector(".custom-add-on-options");
//   var firstVariant = document.querySelectorAll(".custom-add-on-options input");
  
//   if(stitchedInput){
//   if (stitchedInput.checked) {
//     customOptionsDiv.style.display = "block";
//     if (firstVariant.length > 0) {
//       firstVariant[0].checked = true;
//     }
//   } 
 
//   else if (unstitchedInput.checked) {
//     customOptionsDiv.style.display = "none";
//    firstVariant.forEach(function(variant) {
//       variant.checked = false;
//     });
//   }
//  }
//   if(stitchedInput){
//   stitchedInput.addEventListener("click", function() {
//     customOptionsDiv.style.display = "block";
//      if (firstVariant.length > 0) {
//       firstVariant[0].checked = true;
//     }
      
//   });

//   unstitchedInput.addEventListener("click", function() {
//     customOptionsDiv.style.display = "none";
//      firstVariant.forEach(function(variant) {
//       variant.checked = false;
//     });
    
//   });
//   }
// });


document.addEventListener('DOMContentLoaded', function() {
  const body = document.querySelector('body');
  if (body.classList.contains('product')) {
    const typeVariants = document.querySelectorAll('variant-radios input[type="radio"][data-variant-name="type"]');
    const sizeVariants = document.querySelectorAll('variant-radios input[type="radio"][data-variant-name="size"]');
    const sizeFieldsetElement = document.querySelector('.custom-add-on-options')
    const sizeFieldsetElementInput = document.querySelectorAll('.custom-add-on-options input')
    const customSizeOptionAddon = document.querySelector('.custom_size_option_addon')
    const customSizeOptionInputs = document.querySelectorAll('.input-full');
    const customSizeOptionOutputs = document.querySelectorAll('.custom_size_option_addon_img  span[data-size-name]');
    const atcButton = document.querySelector('button.product-form__submit.button');
    const atcButtonText = atcButton.querySelector('span');  
    const custominputsizes = document.querySelectorAll('.hdr-custom-size-opt input');
    const addonProductContainer = document.querySelector('.addon__product-wrap'); 
    const addonProductInput = document.querySelectorAll('.addon-product__input');
    const addonProductQuantityInput = document.querySelectorAll('.addon-product__quantity');
    if (typeVariants) {
      typeVariants.forEach(radioInput => {
        const radioVariantValue = radioInput.getAttribute('data-variant-value');
        if (radioVariantValue === 'unstitched' && radioInput.checked) {
          sizeFieldsetElement.style.display = 'none';
          sizeFieldsetElementInput.forEach(function (input) {
            input.checked = false;
          })
        } else if (radioVariantValue === 'stitched' && radioInput.checked) {
          sizeFieldsetElement.style.display = 'block';
          sizeFieldsetElementInput[0].click();
          if (addonProductContainer) {
            addonProductContainer.style.display = 'block';
          }

        }
        radioInput.addEventListener('change', function(event) {
          const dataVariantValue = this.getAttribute('data-variant-value');
    
          if (dataVariantValue === 'unstitched') {
            sizeFieldsetElement.style.display = "none";                
            sizeFieldsetElementInput.forEach(function (input) {
            input.checked = false;
          })
            if (customSizeOptionAddon) {
              customSizeOptionAddon.style.display = 'none';
              customSizeOptionInputs.forEach(input => {
                input.value = '';
              });
              customSizeOptionOutputs.forEach(output => {
                output.innerText = '';
              });
            }
          } else if (dataVariantValue === 'stitched') {                   
            sizeFieldsetElement.style.display = "block";
            sizeFieldsetElementInput[0].click();
          }
        });
      });
    }

    custominputsizes.forEach(function(checkbox) {
        checkbox.addEventListener('click', function() {
      if (checkbox.getAttribute('value') === 'Custom') {
        customSizeOptionAddon.style.display = "block";
        toggleAddToCartButton();
      }
      else{
        customSizeOptionAddon.style.display = "none";
          atcButton.disabled = false;
         customSizeOptionInputs.forEach(input => {
          input.value = '';
        });
        customSizeOptionOutputs.forEach(output => {
          output.innerText = '';
        });
      }
      });
    });

    if (addonProductContainer) {
      addonProductInput.forEach(input => {
        input.addEventListener('change', function() {
          const targetId = input.getAttribute('data-id');
          const targetInput = document.getElementById(targetId);
      
          if (input.checked) {
            targetInput.disabled = false;
          } else {
            targetInput.disabled = true;
          }
        });
      });
    }
    function toggleAddToCartButton() {
      const allInputsHaveValue = Array.from(customSizeOptionInputs).every(input => input.value.trim() !== '');    
      if (atcButtonText.textContent.trim() ===  'Sold out'){
        atcButton.disabled = true;
      } else {
        atcButton.disabled = !allInputsHaveValue;
      }
    }
  
    if (customSizeOptionInputs) {
      customSizeOptionInputs.forEach(input => {
        input.addEventListener('input', toggleAddToCartButton);
      });    
    }
  }
});





if (body.classList.contains('collection')){

  function initMobileProductCardSliders() {
    const mobileProductCardSlider = document.querySelectorAll('.splide--mobile');
    
    if (mobileProductCardSlider) {
      var elms = mobileProductCardSlider;
      for ( var i = 0; i < elms.length; i++ ) {
        var splide = new Splide(elms[i], {      
            arrows  : true,
            pagination: false
          } );
        splide.mount();
      }
    }
  }
  
  initMobileProductCardSliders();

  function initializeSlidersForNewItems(mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const newGridItems = document.querySelectorAll('ul#product-grid li.grid__item:not(.initialized)');
        if (newGridItems.length > 0) {
          newGridItems.forEach(item => {
            item.classList.add('initialized');
            const sliderContainer = item.querySelector('.splide--mobile');
            if (sliderContainer) {
              var splide = new Splide(sliderContainer, {
                arrows: true,
                pagination: false
              });
              splide.mount();
            }
          });
        }
      }
    }
  }
  
  // Observe mutations in the ul#product-grid
  const productGrid = document.getElementById('product-grid');
  const observer = new MutationObserver(initializeSlidersForNewItems);
  if (observer) {
    observer.observe(productGrid, { childList: true, subtree: true });
  }
}

